import { Component, inject } from '@angular/core';
import { IonApp, IonRouterOutlet, Platform } from '@ionic/angular/standalone';
import { AppService, UiIonicCompModule } from 'ui-ionic-comp';
import { SystemAttributeService } from './backend/system-attributes/system-attribute.service';
import { NavService } from './frontend/navs/nav.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  imports: [IonApp, IonRouterOutlet, UiIonicCompModule]
})
export class AppComponent {

  private appService = inject(AppService);
  private platform = inject(Platform);
  private navService = inject(NavService);
  private systemAttributeService = inject(SystemAttributeService);

  constructor() {

    // Set the system attributes.
    this.initializeSystemAttributes();

    // Check if the app was reloaded and redirect to drafts if so.
    // This is necessary to avoid issues when pages depend on the service variables when reloading.
    // TODO: Make all pages reload-proof and remove this check.
    this.appService.checkReloadAndRedirect(this.navService.routes.home);

    this.platform.ready().then(() => this.initApp());
  }

  private async initApp() {
    const env = 'prod'; // Could dynamically get this from environment.ts

    await this.appService.checkAndEnforceUpdate(env);
  }

  /** Ensures system attributes are loaded ONCE */
  private initializeSystemAttributes() {
    this.systemAttributeService.setDraftTypes();
    this.systemAttributeService.setDraftStatuses();
    this.systemAttributeService.setDraftSeasons();
    this.systemAttributeService.setGenders();
    this.systemAttributeService.setVisibilityGroups();
  }
}
